module.exports = __webpack_public_path__ + "img/5.5f488d4f.jpg";